import { render } from "./ClubNews.vue?vue&type=template&id=11f7d01a&scoped=true"
import script from "./ClubNews.vue?vue&type=script&lang=js"
export * from "./ClubNews.vue?vue&type=script&lang=js"

import "./ClubNews.vue?vue&type=style&index=0&id=11f7d01a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f7d01a"]])

export default __exports__